import { useLogger } from "@agportal/logger";
import { createRestClient } from "@dmvs/client";
import { strict as assert } from "assert";
import { isEmpty, isNil } from "lodash-es";

/**
 * Service to offer access methods for subjects' users.
 */
export default class PovereniSubjektuService {
    constructor(url) {
        assert(url, "url has to be specified");

        this.logger = useLogger();
        this.rest = createRestClient({
            baseURL: url,
        });
    }

    async vylistujPozadavkyNaPovereniSubjektu(subjekt, query) {
        if (!isEmpty(query)) {
            const { data } = await this.rest.post(`/by-id/${subjekt}/povereni/subjekt/pozadavky/query`, query);

            this.logger.debug(
                "PovereniSubjektuService.vylistujPozadavkyNaPovereniSubjektu" +
                " for subject {0} and query {1} returns {2}",
                subjekt,
                query,
                data
            );

            return data;
        }
    }

    async vylistujPozadavkyNaPovereniOsoby(subjekt, query) {
        if (!isEmpty(query)) {
            const { data } = await this.rest.post(`/by-id/${subjekt}/povereni/uzivatel/pozadavky/query`, query);

            this.logger.debug(
                "PovereniSubjektuService.vylistujPozadavkyNaPovereniOsoby" +
                " for subject {0} and query {1} returns {2}",
                subjekt,
                query,
                data
            );

            return data;
        }
    }

    async poverOsobu(subjekt, zadost) {
        if (!isEmpty(zadost)) {
            const { data } = await this.rest.post(`/by-id/${subjekt}/povereni/uzivatel`, zadost);

            this.logger.debug(
                "PovereniSubjektuService.poverOsobu" + " for subject {0} and request {1} returns {2}",
                subjekt,
                zadost,
                data
            );

            return data;
        }
    }

    async poverSubjekt(subjekt, zadost) {
        if (!isEmpty(zadost)) {
            const { data } = await this.rest.post(`/by-id/${subjekt}/povereni/subjekt`, zadost);

            this.logger.debug(
                "PovereniSubjektuService.poverSubjekt" + " for subject {0} and request {1} returns {2}",
                subjekt,
                zadost,
                data
            );

            return data;
        }
    }

    async zrusPovereniOsoby(subjekt, payload) {
        if (!isEmpty(payload)) {
            const { data } = await this.rest.post(`/by-id/${subjekt}/povereni/uzivatel/zruseni`, payload);

            this.logger.debug(
                "PovereniSubjektuService.zrusPovereniOsoby" + " for subject {0} and payload {1} returns {2}",
                subjekt,
                payload,
                data
            );

            return data;
        }
    }

    async zrusPovereniSubjektu(subjekt, payload) {
        if (!isEmpty(payload)) {
            const { data } = await this.rest.post(`/by-id/${subjekt}/povereni/subjekt/zruseni`, payload);

            this.logger.debug(
                "PovereniSubjektuService.zrusPovereniSubjektu" + " for subject {0} and payload {1} returns {2}",
                subjekt,
                payload,
                data
            );

            return data;
        }
    }

    async zrusPozadavekNaPovereniOsoby(subjekt, pozadavek) {
        if (!isNil(subjekt) && !isNil(pozadavek)) {
            const { data } = await this.rest.post(`/by-id/${subjekt}/povereni/uzivatel/pozadavky/by-id/${pozadavek}/storno`);

            this.logger.debug(
                "PovereniSubjektuService.zrusPozadavekNaPovereniOsoby" + " for subject {0} and request {1} returns {2}",
                subjekt,
                pozadavek,
                data
            );

            return data;
        }
    }

    async zrusPozadavekNaPovereniSubjektu(subjekt, pozadavek) {
        if (!isNil(subjekt) && !isNil(pozadavek)) {
            const { data } = await this.rest.post(`/by-id/${subjekt}/povereni/subjekt/pozadavky/by-id/${pozadavek}/storno`);

            this.logger.debug(
                "PovereniSubjektuService.zrusPozadavekNaPovereniSubjektu" + " for subject {0} and request {1} returns {2}",
                subjekt,
                pozadavek,
                data
            );

            return data;
        }
    }

    async nactiMozneTypyPovereniOsoby(subjekt) {
        if (!isNil(subjekt)) {
            const { data } = await this.rest.get(`/by-id/${subjekt}/povereni/uzivatel/mozne-typy`);

            this.logger.debug(
                "PovereniSubjektuService.nactiMozneTypyPovereniOsoby for subjekt {0} returns {1}",
                subjekt,
                data
            );

            return data;
        }
    }

    async nactiMozneTypyPovereniSubjektu(subjekt) {
        if (!isNil(subjekt)) {
            const { data } = await this.rest.get(`/by-id/${subjekt}/povereni/subjekt/mozne-typy`);

            this.logger.debug(
                "PovereniSubjektuService.nactiMozneTypyPovereniSubjektu for subjekt {0} returns {1}",
                subjekt,
                data
            );

            return data;
        }
    }
}
